import React from "react";
import { Link } from "react-router-dom";
import { MessageSquare } from "lucide-react";
import { TECHNOLOGY, IMAGES } from "../data/site";
import { SectionHeading } from "../components/SectionHeading";
import { Seo } from "../components/Seo";
import { SEO, breadcrumbSchema } from "../data/seo";

export const TechnologyPage = () => (
  <div data-testid="technology-page">
    <Seo
      title={SEO.technology.title}
      description={SEO.technology.description}
      image={IMAGES.technology}
      schemas={[breadcrumbSchema([{ name: "Home", path: "/" }, { name: "Technology", path: "/technology" }])]}
    />
    <section className="relative h-[70vh] min-h-[500px] overflow-hidden">
      <img src={IMAGES.technology} alt="" className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 bg-ink/65" />
      <div className="relative h-full container-wide flex flex-col justify-end pb-20 text-white">
        <div className="label-eyebrow text-gold mb-6">Technology</div>
        <h1 className="heading-display text-5xl md:text-7xl lg:text-8xl max-w-4xl text-white">
          Precision <span className="italic text-gold-light">tools.</span> Human hands.
        </h1>
        <p className="text-white/70 mt-8 max-w-2xl text-lg">
          We invest in the technology that makes care more comfortable, more predictable, more beautiful. Tools serve craft — not the other way around.
        </p>
      </div>
    </section>

    <section className="py-24 md:py-32 container-x">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-ink/10">
        {TECHNOLOGY.map((t, i) => (
          <div
            key={i}
            data-testid={`tech-card-${i}`}
            className="bg-bone p-10 md:p-12 reveal group"
            style={{ transitionDelay: `${i * 60}ms` }}
          >
            <div className="font-serif text-5xl font-light text-gold mb-8">{String(i + 1).padStart(2, "0")}</div>
            <h3 className="font-serif text-2xl md:text-3xl font-light leading-tight group-hover:text-gold transition-colors">{t.name}</h3>
            <p className="text-ink/60 mt-4 leading-relaxed">{t.desc}</p>
          </div>
        ))}
      </div>
    </section>

    <section className="py-24 bg-ink text-bone text-center">
      <div className="container-x">
        <MessageSquare size={32} strokeWidth={1} className="text-gold mx-auto mb-6" />
        <SectionHeading title="Curious about a" italicWord="tool?" align="center" light />
        <p className="text-white/60 mt-6 max-w-md mx-auto">Ask our team. We're happy to walk you through anything in our studios.</p>
        <Link to="/contact" data-testid="tech-contact-cta" className="btn-outline-light mt-10 inline-flex">Get in Touch</Link>
      </div>
    </section>
  </div>
);
